import type { ButtonVariant } from '@lightspeed/design-system-react'
import type { ReactNode } from 'react'
import type { FulfilmentDetail } from '../../../../../../models/fulfilment'

export const EditAddressButtons = {
  edit: 'edit',
  add: 'add',
  addShipping: 'addShipping',
} as const

export type AddOrEditAddressButtonType = keyof typeof EditAddressButtons

export interface EditAddressButtonProps {
  type: AddOrEditAddressButtonType
  isModalOpeningOnError?: boolean
  hasError?: boolean
  text?: ReactNode
  variant?: ButtonVariant
  onClick?: () => void
  onClose?: () => void
  onSave?: (fulfilmentDetails: FulfilmentDetail[]) => void
  fulfilmentDetail?: FulfilmentDetail
  lineItemLocalId?: string
  onOpenModal: () => void
}
